(function($) {
  
    $(document).ready(function() {
        
    });
  
})(jQuery);

function initPrecontentSlider(){
    var $ = jQuery;
    $(window).on('resize',function(){
        $('.m-precontent-slider .slide iframe').each(function(){
            var width = $(this).attr('width');
            var height = $(this).attr('height');
            if(!width){width=16;}
            if(!height){height=9;}
            var ratio = height/width;
            ratio = 0.705;
            $(this).css('height',$(this).outerWidth()*ratio)
        })
    }).trigger('resize')
    /*$('.precontent-prev').click(function(){
        var y = $('.pager-precontent-slider').scrollLeft();  //your current y position on the page
        $('.pager-precontent-slider').animate({scrollLeft:y-150},300);
    })
    $('.precontent-next').click(function(){
        var y = $('.pager-precontent-slider').scrollLeft();  //your current y position on the page
        $('.pager-precontent-slider').animate({scrollLeft:y+150},300);
    })*/
    $('#precontent-slider').on('cycle-before',function(){
        $('.slide-video').each(function(){
            var savethehtml = $(this).html();
            $(this).html('');
            $(this).html(savethehtml);
        })
    })
    $('.pager-precontent-slider .slide').click(function(){
        $('#precontent-slider').cycle('goto',$(this).attr('data-slide'));
    })
}